import {Component} from '@angular/core';
import {AppTopBarComponent} from '../app.topbar.component';
import {CbetMainComponent} from './cbet-main.component';

// Topbar de Avalon con los mismos datos y acciones del topbar de Teki.
@Component({
    selector: 'app-cbet-topbar',
    templateUrl: './cbet-topbar.component.html',
    styleUrls: ['./cbet-topbar.component.scss'],
    standalone: false
})
export class CbetTopbarComponent extends AppTopBarComponent {

    get main(): CbetMainComponent {
        return this.appMain as CbetMainComponent;
    }
}
